import {ListBase, ListProps, Record, useDataProvider, useListContext, useNotify, usePermissions} from "react-admin";
import {Button, Card, Table} from "antd";
import * as React from "react";
import {ExtendedDataProvider, RoutableTabConfig} from "@src/types";
import {Link} from "react-router-dom";
import {EditOutlined} from "@ant-design/icons";
import SkeletonTable, {SkeletonTableColumnsType} from "../Common/SkeletonTable";
import ResponseListView from "../Common/HTTPResponseList";
import {HealthCheckResponsesColumns} from "../Common/Columns";
import RoutableTabs from '../Common/RoutableTabs';
import { spinnerElement } from '../Common/utils';

const HealthcheckListView = () => {
  const { ids, data, loading, total, perPage, setPage, page } = useListContext();
  const dataProvider: ExtendedDataProvider = useDataProvider();
  const notify = useNotify();
  const { permissions } = usePermissions();

  const triggerForService = (record: any) => {
    dataProvider.getAction('serviceowner_healthchecks', {verb: "trigger/service/"+record.service.id})
      .then((response: any) => {
        notify('Healthcheck triggered successfully')
      }).catch((error: any) => {
        notify('Error triggering healthcheck', 'error')
      })
  }
  const permissionChangeState = ["ADMIN", "GENERAL"].includes(permissions);

  const columns = [
    {
      title: 'Service',
      dataIndex: ['service', 'name'],
      key: 'service',
    },
    {
      title: 'Target URL',
      dataIndex: 'target_url',
      key: 'target_url',
      render: (text: any, record: any) => <div title={text} style={{ width: '150px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{text}</div>
    },
    {
      title: 'Crontab',
      dataIndex: 'schedule_crontab',
      key: 'schedule_crontab',
    },
    {
      render: (text: any, record: any) =>
        <div>
          {
            permissionChangeState &&
              <Button style={{ marginRight: '5px'}} onClick={() => triggerForService(record)}>
                Trigger for Service
              </Button>
          }
          <Button style={{ marginRight: '5px'}}>
            <Link to={`/serviceowner_healthchecks/${record.id}`}><EditOutlined />{permissions === "ADMIN"?"Edit":"Show"}</Link>
          </Button>
        </div>

    },

  ]
  const tableData: Record[] = []
  ids.forEach(id => {
    tableData.push(data[id])
  });

  if (loading) {
    return spinnerElement;
  }

  return (
    <Card
      bordered={false}
      className="criclebox tablespace mb-24"
    >
      <SkeletonTable loading={loading} columns={columns as SkeletonTableColumnsType[]}>
        <Table
          rowKey='id'
          columns={columns}
          pagination={{ total: total, pageSize: perPage, current: page, onChange: page => setPage(page), className: "pagination-padding" }}
          dataSource={tableData}
        />
      </SkeletonTable>
    </Card>
  )
}


const HealthcheckList = (props: ListProps) => {
    const { permissions } = usePermissions();

    const handleTabChange = (activeKey: string) => {
        // console.log('Active tab changed to:', activeKey);
    };

    const tabs: RoutableTabConfig[] = [
        {
            key: 'healthchecks',
            tab: <span>Healthchecks</span>,
            content: <ListBase {...props}><HealthcheckListView /></ListBase>,
        },
        {
            key: 'responses',
            tab: <span>Responses</span>,
            content: <ResponseListView columns={HealthCheckResponsesColumns} resource_name={"serviceowner_healthcheck_responses"} filters={{}}/>,
        },
    ];

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '8px' }}>
                {permissions === "ADMIN" && <Link to="/serviceowner_healthchecks/create"><Button type='primary'>Create Healthcheck</Button></Link>}
            </div>
            <RoutableTabs tabs={tabs} defaultActiveKey="healthchecks" onTabChange={handleTabChange} />
        </div>
    );
};

export default HealthcheckList;
